import React from 'react';
import { ReactNode } from 'react';

// Define el tipo OptionFloating como lo tienes en tu componente
export type OptionFloating = {
  id?: string;
  title: string;
  description: string;
  icon: ReactNode;
  action?: string | (() => void);
  target?: "_blank" | "_self" | "_parent" | "_top";
  visibility?: "desktop" | "mobile" | "both";
};

interface InputData {
  opciones: any[];
  icono: {
    file: {
      url: string;
    };
  };
  iconoCerrar: {
    file: {
      url: string;
    };
  };
}

/**
 * Adapta la estructura de datos de botones internos a un array de OptionFloating.
 * @param dataArray El array de datos de entrada.
 * @returns Un array de OptionFloating.
 */
export const adaptToOptionFloating = (dataArray: InputData[]): OptionFloating[] => {
  if (!dataArray || dataArray.length === 0 || !dataArray[0].opciones) {
    return [];
  }

  const baseContentfulUrl = "https:"; // Contentful URLs a menudo son relativas, es buena práctica añadir el protocolo

  return dataArray[0].opciones.map((boton, index) => {

    return {
      id: `option-${index}`, // Genera un ID único, o puedes usar el nombre si es único
      title: boton.nombre,
      description: boton.descripcion,
      icon: boton.icono ?
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', height: '48px', paddingInline: '6px', backgroundColor: '#f3f3f3' }}>
          <i className={`icon-${boton.icono}`} style={{ marginLeft: '1px', fontSize: '36px', color: '#ee2b7b' }} />
        </div> : <img src={`${baseContentfulUrl}${boton.iconoImagen.file.url}`} alt={boton.nombre} style={{ width: '24px', height: '24px' }} />,
      action: boton.link,
      target: "_blank", // Asumimos que los enlaces internos abren en una nueva pestaña
      visibility: boton.visibilidad ?? "both", // Puedes ajustar esto si la visibilidad es condicional
    };
  });
};